import { getDay, isBefore, isValid, parse } from "date-fns"
import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz"

const minDateGap = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const torontoTime = utcToZonedTime(
    zonedTimeToUtc(new Date(), timezone),
    "America/Toronto"
  )

  const curr = parse("4:00 pm", "h:mm a", torontoTime)

  if (!isValid(curr)) return 1

  const endDate = format(curr, "yyyy-MM-dd HH:mm:ss", {
    timeZone: "America/Toronto",
  })

  const dayEnd = zonedTimeToUtc(endDate, "America/Toronto")

  const day = getDay(torontoTime)

  let gap = 0
  if (day === 6) gap = 2
  else if (day === 0) gap = 1
  if (isBefore(dayEnd, new Date())) {
    // time passed!
    if (day === 5) gap = 3
    else if (day === 6) gap = 2
    else gap = 1
  }
  return gap
}

export default minDateGap
